import { UserApi } from '../../../api';
import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { MedicalLeaveRequestBaseResponseDto } from '../../../commonTypes/user.types';

const useHttpGetMedicalLeaveRequestsForUserOnMount = (page?: number, size?: number, sort?: string, direction?: 'asc' | 'desc') => {
    const userApi: UserApi = useContainer(UserApi);
    const [data, setData] = useState<MedicalLeaveRequestBaseResponseDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    const { exec, abort } = userApi.medicalLeaveRequestsForUser({
        query: {
            ...(page && { page }),
            ...(size && { size }),
            ...(sort && { sort }),
            ...(direction && { direction }),
        },
        onSuccess: res => {
            const medicalLeaveRequestsForUser = res.body;
            setData(medicalLeaveRequestsForUser.items);
            setTotal(parseInt(medicalLeaveRequestsForUser.total));
            setLoading(false);
        },
        onError: error => {
            console.log(error);
            setLoading(false);
        },
    });

    useEffect(() => {
        return () => abort();
    }, []);

    return { exec, abort, data, setData, total, setTotal, loading, setLoading };
};

export default useHttpGetMedicalLeaveRequestsForUserOnMount;
